import React from 'react';
import { UserTie, UserShield } from '@insurancemenu/imenu-components-lib/dist/icons';
import { UserRoleTypes } from 'types/aaaService';
import { createStyles } from './styles';

export interface RoleTypeCardProps {
  type: UserRoleTypes;
  selectedRoleType: UserRoleTypes | null;
  onCardClick: (e: React.SyntheticEvent<HTMLLIElement>) => void;
}

export interface ROLE_TYPE_DATA_MAP {
  title: string;
  icon: JSX.Element;
}

const RoleTypeCard = ({ type, selectedRoleType, onCardClick }: RoleTypeCardProps): JSX.Element => {
  const classes = createStyles();

  const RoleTypeIconsMap: Record<UserRoleTypes, ROLE_TYPE_DATA_MAP> = Object.freeze({
    EE: { title: 'EMPLOYEE/EMPLOYER', icon: <UserTie /> },
    AGENT: { title: 'AGENT/CARRIER', icon: <UserShield /> },
  });

  return (
    <li
      id={`role-type-${type}`}
      className={selectedRoleType === type ? classes.selectedTypeCard : classes.typeCard}
      onClick={onCardClick}
      data-role-type={type}
      role="menuitem"
      tabIndex={0}
      onKeyDown={onCardClick}
    >
      <div className={selectedRoleType === type ? classes.selectedIconBlock : classes.iconBlock}>
        {RoleTypeIconsMap[type].icon}
      </div>
      <h3 className={classes.cardTitle}>{RoleTypeIconsMap[type].title}</h3>
    </li>
  );
};

export default RoleTypeCard;
